// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OkNI","title":"Header_title__3Izh3","side":"Header_side__OjiXf"};